import { z } from "zod";

const optionalRate = z
	.string()
	.refine((v) => v === "" || (!Number.isNaN(Number(v)) && Number(v) >= 0), {
		message: "Wprowadź poprawną wartość (liczba ≥ 0)",
	})
	.optional();

export const createDistrictSchema = z.object({
	name: z.string().min(1, "Nazwa osiedla jest wymagana"),
	managerId: z.string().min(1, "Wybierz zarządcę"),
});
export type CreateDistrictFormValues = z.infer<typeof createDistrictSchema>;

export const createApartmentSchema = z.object({
	street: z.string().min(1, "Ulica jest wymagana"),
	apartmentNumber: z.string().min(1, "Numer lokalu jest wymagany"),
	coldWaterRate: optionalRate,
	hotWaterRate: optionalRate,
	heatRate: optionalRate,
	consumptionRate: optionalRate,
});
export type CreateApartmentFormValues = z.infer<typeof createApartmentSchema>;

export const updateApartmentSchema = z.object({
	street: z.string().min(1, "Ulica jest wymagana"),
	apartmentNumber: z.string().min(1, "Numer lokalu jest wymagany"),
	coldWaterRate: optionalRate,
	hotWaterRate: optionalRate,
	heatRate: optionalRate,
	consumptionRate: optionalRate,
});
export type UpdateApartmentFormValues = z.infer<typeof updateApartmentSchema>;
